import { Component, OnInit, Input } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslateService } from 'ng2-translate';

import { ProjectsService } from '../../services/projects.service';
import { IssuesService } from '../../../issues/services/issues.service';
import { AlertManagerService } from '../../../../shared/services/alert-manager.service';

import { Version } from '../../../../modules/models/version';
import { WorkConstants } from '../../work.const';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';

@Component({
  selector: 'app-project-sprint',
  templateUrl: './project-sprint.component.html',
  styleUrls: ['./project-sprint.component.css']
})
export class ProjectSprintComponent implements OnInit {


  @Input() projectId: number;
  sprintId: number = 0;

  //sprint 
  sprintPageId: number = 1;
  sprintPerPage: number = 0;
  sprintCount: number = 0;
  sprintPageCount: number = 1;

  sprints: Array<any> = [];
  workConstants: any = WorkConstants;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,
    private issuesService: IssuesService
  ) { }

  ngOnInit() {
    this.getSprints(this.sprintPageId);
  }

  /**
     * get all sprint in project
     */
  getSprints(sprintPageId) {
    if (!sprintPageId) {// if sprint page id is undifine
      sprintPageId = this.sprintPageId;
    }
    this.projectsService.getSprints(this.projectId, sprintPageId).subscribe(
      sprints => {
        if(sprints.data && sprints.data.data){
        this.sprints = sprints.data.data;
        this.sprintPageId = sprints.data.current_page
        this.sprintCount = sprints.data.total
        this.sprintPageCount = sprints.data.last_page
        this.sprintPerPage = sprints.data.per_page
        }
        this.scrollThePage();
      }
    );
  }

  /**
   * kauhslya
   * 2017-08-03
   * change the page according to the pagination event
   * @param event
   */
  sprintPageChanged(event) {
    this.getSprints(event);
  }

  /**
     * kauhslya
     * 2017-08-14
     * scroll The Page
     * @param event
    //  */
  scrollThePage() {
    window.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/components/project-sprint/project-sprint.component.ts